import { useState } from 'react';

// Hộp tạo BÌNH CHỌN (chỉ nhóm): câu hỏi + các phương án (thêm/bớt) + cho phép chọn nhiều.
export default function PollComposer({ onCancel, onCreate }) {
  const [question, setQuestion] = useState('');
  const [options, setOptions] = useState(['', '']);
  const [multi, setMulti] = useState(false);

  const setOpt = (i, v) => setOptions((prev) => prev.map((o, k) => (k === i ? v : o)));
  const addOpt = () => setOptions((prev) => (prev.length >= 10 ? prev : [...prev, '']));
  const delOpt = (i) => setOptions((prev) => (prev.length <= 2 ? prev : prev.filter((_, k) => k !== i)));

  const clean = options.map((o) => o.trim()).filter(Boolean);
  const valid = question.trim() && clean.length >= 2;

  return (
    <div className="poll-compose" onMouseDown={(e) => e.preventDefault()}>
      <div className="poll-compose-title">📊 Tạo bình chọn</div>
      <input
        className="poll-input"
        placeholder="Câu hỏi bình chọn…"
        value={question}
        onChange={(e) => setQuestion(e.target.value)}
        autoFocus
      />
      {options.map((o, i) => (
        <div className="poll-opt-row" key={i}>
          <input
            className="poll-input"
            placeholder={`Phương án ${i + 1}`}
            value={o}
            onChange={(e) => setOpt(i, e.target.value)}
          />
          {options.length > 2 && (
            <button type="button" className="poll-opt-del" title="Xoá phương án" onClick={() => delOpt(i)}>✕</button>
          )}
        </div>
      ))}
      {options.length < 10 && (
        <button type="button" className="poll-add" onClick={addOpt}>+ Thêm phương án</button>
      )}
      <label className="poll-multi">
        <input type="checkbox" checked={multi} onChange={(e) => setMulti(e.target.checked)} /> Cho phép chọn nhiều phương án
      </label>
      <div className="poll-compose-actions">
        <button type="button" className="btn sm ghost" onClick={onCancel}>Huỷ</button>
        <button type="button" className="btn sm" disabled={!valid} onClick={() => onCreate({ question: question.trim(), options: clean, multi })}>
          Gửi bình chọn
        </button>
      </div>
    </div>
  );
}
